import { createReducer, on } from '@ngrx/store';
import { SheetTemplate } from 'src/app/types/sheet.types';
import * as authActions from '../auth/auth.actions';
import * as sheetTemplateManagementActions from './sheet-template-management.actions';

export interface State {
	templates: SheetTemplate[];
}

export const initialState: State = {
	templates: []
}

export const sheetTemplateManagementReducer = createReducer(
	initialState,
	on(sheetTemplateManagementActions.loadTemplatesCompleted, (state, { templates }) => ({
		...state,
		templates: [...templates].sort(sortSheetTemplatesByNameThenCreatedDateAsc)
	})),
	on(sheetTemplateManagementActions.renameTemplateCompleted, (state, { template }) => ({
		...state,
		templates: state.templates.map(t => t.id === template.id ? template : t).sort(sortSheetTemplatesByNameThenCreatedDateAsc)
	})),
	on(sheetTemplateManagementActions.changeTemplateActiveStateCompleted, (state, { template }) => ({
		...state,
		templates: state.templates.map(t => t.id === template.id ? template : t).sort(sortSheetTemplatesByNameThenCreatedDateAsc)
	})),
	on(sheetTemplateManagementActions.deleteTemplateCompleted, (state, { templateId }) => ({
		...state,
		templates: state.templates.filter(t => t.id !== templateId)
	})),
	on(sheetTemplateManagementActions.templatesUnloaded, () => initialState),
	on(authActions.clearStateRequested, () => initialState)
);

const sortSheetTemplatesByNameThenCreatedDateAsc = (a: SheetTemplate, b: SheetTemplate) => {
	const nameA = (a.name ?? '').toUpperCase(); // ignore upper and lowercase
	const nameB = (b.name ?? '').toUpperCase(); // ignore upper and lowercase
	if (nameA < nameB) {
		return -1;
	}
	if (nameA > nameB) {
		return 1;
	}
	return b.createdDate.localeCompare(a.createdDate);
};